export default __webpack_public_path__ + "static/media/qlik-info-2.eaf34dfa.png";